import { render, staticRenderFns } from "./Speech2text.vue?vue&type=template&id=191c13ec&scoped=true&"
import script from "./Speech2text.vue?vue&type=script&lang=js&"
export * from "./Speech2text.vue?vue&type=script&lang=js&"
import style0 from "./Speech2text.vue?vue&type=style&index=0&id=191c13ec&prod&lang=less&scoped=true&"
import style1 from "./Speech2text.vue?vue&type=style&index=1&id=191c13ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c13ec",
  null
  
)

export default component.exports